import { NoRecordFound } from 'components/Common/Common';
import ErrorComponent from 'components/shared/ErrorComponent';
import LoadingIndicator from 'components/shared/LoadingIndicator';
import TableLayout from 'components/TableLayout';
import { CLIENT_TYPE_OPTIONS, FUTUTRE_DATE_ERROR_MESSAGE } from 'config/constants';
import { MANAGE_SUPPORT_STAFF_CLIENT_TASKS_SESSION_VIEW } from 'config/paths';
import { convertToMomentDate, errorMessageToast, formatString, userFullName } from 'helpers/common';
import moment from 'moment';
import React, { useEffect, useState } from 'react'
import { Accordion, Button, Col, Container, Row } from 'react-bootstrap'
import { generatePath, Link, useNavigate } from 'react-router-dom';
import { useLazyGetTaskDetailsStaffQuery } from 'store/services/supportStaff';

export const SingleTaskAccordion = ({ tasks, clientId, staffId, taskType }) => {
    const [currentTask, setCurrentTask] = useState(null)

    const [getTaskDetails] = useLazyGetTaskDetailsStaffQuery()
    const navigate = useNavigate();
    const [showModal, setShowModal] = useState(false);
    const [selectedOwnerId, setSelectedOwnerId] = useState('');
    const [selectedTaskId, setSelectedTaskId] = useState('');
    const [isTaskCompleted, setIsTaskCompleted] = useState('');
    const [detailsList, setDetailsList] = useState({});
    const [loaderObj, setLoaderObj] = useState({})



    useEffect(() => {
        let isCancelled = false;

        const fetchSequentially = async () => {
            const resultMap = {};
            for (const record of tasks) {
                if (isCancelled) {
                    break;
                }
                try {
                    const detail = await getTaskDetails({ id: staffId, taskType, clientId, taskId: record?.associatedTasks?.id }).unwrap();
                    setDetailsList((prev) => ({ ...prev, [record?.associatedTasks?.id]: detail }))
                    setLoaderObj((prev) => ({ ...prev, [record?.associatedTasks?.id]: false }))
                } catch (err) {
                    setDetailsList((prev) => ({ ...prev, [record?.associatedTasks?.id]: null }))
                    setLoaderObj((prev) => ({ ...prev, [record?.associatedTasks?.id]: false }))
                    console.error('Failed to fetch detail:', err);
                }
            }
        };

        if (tasks?.length) {
            for (const record of tasks) {
                setLoaderObj((prev) => ({ ...prev, [record?.associatedTasks?.id]: true }))
            }
            fetchSequentially();
        }

        return () => {
            isCancelled = true;
        };
    }, [tasks]);


    const column = [
        {
            head: "Schedule Date",
            accessor: "Session Date",
            isComponent: true,
            component: (item) => <>{convertToMomentDate(item?.schedule_date)}</>,
        },
        {
            head: "Attendance",
            accessor: "Tracker",
            component: (item) => <div className='text-capitalize'>{item?.attendance || "--"}</div>,
        },
        {
            head: "Status",
            accessor: "Confirmed",
            sorter: true,
            isComponent: true,
            component: (item) => (
                <p
                    style={{ width: 110 }}
                    className={`${item?.status === "pending" ? "yellowStatus" : "greenStatus"} status fw-bold text-capitalize m-0 text-center d-flex align-items-center justify-content-center rounded-pill px-4 py-1`}
                >
                    {formatString(item?.status)}
                </p>
            ),
        },
        {
            head: "Action",
            accessor: "Action",
            isComponent: true,
            component: (item) => {
                const scheduleDate = new Date(item?.schedule_date);
                const currentDate = new Date();
                const isFutureDate = scheduleDate > currentDate;

                return (
                    <div onClick={() => isFutureDate && errorMessageToast(FUTUTRE_DATE_ERROR_MESSAGE)}
                    >
                        <Link
                            target='_blank'
                            to={{
                                pathname: generatePath(MANAGE_SUPPORT_STAFF_CLIENT_TASKS_SESSION_VIEW, {
                                    staffId: staffId,
                                    clientId: clientId,
                                    taskId: item?.assigned_task_id,
                                }),
                                search: `?task_datetime=${encodeURIComponent(moment.utc(item?.schedule_date).format("YYYY-MM-DDTHH:mm:ssZ"))}`
                            }}
                            className={`btn text-white d-flex align-items-center justify-content-center commonBtn fw-sbold`}
                            // className="btn text-white d-flex align-items-center justify-content-center commonBtn fw-sbold "

                            style={{
                                height: "35px",
                                maxWidth: "100px",
                                pointerEvents: isFutureDate ? 'none' : 'auto', // Disable click if needed
                                opacity: isFutureDate ? 0.5 : 1,              // Visual cue for disabled
                            }}
                        >
                            Target Plan
                        </Link>
                    </div>
                );
            },
        }
    ];

    const getClientTypeLabel = (clientTypeValue) => {
        const clientType = CLIENT_TYPE_OPTIONS.find(type => type.value === clientTypeValue);
        return clientType ? clientType.label : "--";
    };

    const defaultActiveKeys = tasks?.map((_, index) => index.toString())

    const [activeKeys, setActiveKeys] = useState([]); // Allow multiple open

    const handleAccordionToggle = (key) => {
        setActiveKeys(prevKeys =>
            prevKeys.includes(key)
                ? prevKeys.filter(k => k !== key) // remove key (collapse)
                : [...prevKeys, key] // add key (expand)
        );
    }; console.log('detailsList', detailsList)

    return (
        <Accordion defaultActiveKey={defaultActiveKeys} alwaysOpen>
            {
                tasks?.map((item, index) =>
                    <Accordion.Item key={index} onClick={() => setCurrentTask(item)} eventKey={index.toString()}>
                        <Accordion.Header className='staff-client-accordion'>
                            <div className='d-flex aalign-items-center justify-content-between w-100 align-items-center'>
                                <div>
                                    <div className='mb-2'>
                                        <span>Title:</span> {item?.associatedTasks?.task_title}
                                    </div>
                                    <div className='text-capitalize'>
                                        Task: {item?.associatedTasks?.task_type == "single" ? "Individual" : (item?.associatedTasks?.task_type || "--")}
                                    </div>
                                </div>
                                <div style={{ marginRight: "10px" }}>
                                    <div className='mb-2'>
                                        Start Date: {convertToMomentDate(item?.associatedTasks?.task_datetime) || "--"}
                                    </div>
                                    <div>
                                        End Date: {item?.associatedTasks?.ends_on_data?.endDate ? convertToMomentDate(item?.associatedTasks?.ends_on_data?.endDate) : detailsList[item?.associatedTasks?.id]?.tasks[0]?.occurrences[detailsList[item?.associatedTasks?.id]?.tasks[0]?.occurrences?.length - 1]?.schedule_date ? convertToMomentDate(detailsList[item?.associatedTasks?.id]?.tasks[0]?.occurrences[detailsList[item?.associatedTasks?.id]?.tasks[0]?.occurrences?.length - 1]?.schedule_date) : "--"}
                                    </div>
                                </div>
                            </div>
                        </Accordion.Header>
                        <Accordion.Body>
                            {
                                loaderObj[item?.associatedTasks?.id] ? (
                                    <div style={{ height: "200px" }}>
                                        <LoadingIndicator inline={true} />
                                    </div>
                                ) :
                                    <>
                                        <section className='mt-4'>
                                            <Container fluid>
                                                {/* <h4 className='m-0 fw-bold themeBlue text-capitalize'>{userFullName(detailsList[item?.associatedTasks?.id]?.clientDetails?.associatedClient)}</h4> */}
                                                <Row>
                                                    <Col lg='12'>
                                                        <Row>
                                                            {[
                                                                // { label: "Last Name", value: detailsList[item?.associatedTasks?.id]?.clientDetails?.associatedClient?.lastname },
                                                                // { label: "First Name", value: detailsList[item?.associatedTasks?.id]?.clientDetails?.associatedClient?.firstname },
                                                                // { label: "DOB", value: convertToMomentDate(detailsList[item?.associatedTasks?.id]?.clientDetails?.associatedClient?.client_detail?.dob) },
                                                                { label: "Name of Discipline", value: detailsList[item?.associatedTasks?.id]?.tasks?.[0]?.associatedTasks?.owner?.therapist_detail?.therapist_discipline?.name },
                                                                { label: "Supervisor", value: userFullName(detailsList[item?.associatedTasks?.id]?.tasks?.[0]?.associatedTasks?.owner) },
                                                                // { label: "Client Type", value: getClientTypeLabel(detailsList[item?.associatedTasks?.id]?.clientDetails?.associatedClient?.client_detail?.client_type) },
                                                                // { label: "Grade", value: detailsList[item?.associatedTasks?.id]?.clientDetails?.associatedClient?.client_detail?.grade },
                                                            ].map((item, index) => (
                                                                <Col md="6" sm="6" className='my-2' key={index}>
                                                                    <div className="cardCstm p-3 bg-white shadow h-100 rounded">
                                                                        <h6 className="m-0 themeBlue fw-bold">
                                                                            <span style={{ color: 'rgb(61, 160, 170)' }}>■</span>{" "}
                                                                            {item.label}
                                                                        </h6>
                                                                        <p className="m-0 themeBlue pt-2">{item.value || "--"}</p>
                                                                    </div>
                                                                </Col>
                                                            ))}
                                                        </Row>
                                                    </Col>
                                                </Row>
                                            </Container>
                                        </section>
                                        <section className='mt-4'>
                                            <Container fluid>
                                                {
                                                    !detailsList[item?.associatedTasks?.id]?.tasks?.length ? <NoRecordFound /> : detailsList[item?.associatedTasks?.id]?.tasks?.map((item, index) => (
                                                        <div key={index} className='p-4 pb-0 rounded mt-3' style={{ backgroundColor: "#3DA0AA17" }}>
                                                            <div className="pb-4 h-100 rounded d-flex align-items-center">
                                                                <h6 className="m-0 themeBlue fw-bold">
                                                                    <span style={{ color: 'rgb(61, 160, 170)' }}>■</span>{" "}
                                                                    Date
                                                                </h6>
                                                                <div className='d-flex ms-2 align-items-center'>
                                                                    {/* <img src={Images.calender_grey_img} alt="calender_grey_img" /> */}
                                                                    <p className="m-0 themeBlue ms-1">
                                                                        {convertToMomentDate(item?.associatedTasks?.createdAt)}
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <div className="d-flex justify-content-between">
                                                                <h5 className='m-0 fw-bold themeBlue text-capitalize'>{item?.associatedTasks?.task_title || "--"}</h5>
                                                                {/* <Button
                                                                            disabled={item?.associatedTasks?.status === 'completed'}
                                                                            className='commonBtn btn btn-primary p-0'
                                                                            style={{
                                                                                height: "35px",
                                                                                backgroundColor: item?.associatedTasks?.status === 'completed' ? '#45a3a5' : '',
                                                                                borderColor: item?.associatedTasks?.status === 'completed' ? '#45a3a5' : ''
                                                                            }}
                                                                        >
                                                                            {item?.associatedTasks?.status === 'completed' ? 'Completed' : 'In complete'}
                                                                        </Button> */}
                                                                <div> <p
                                                                    style={{ width: 110 }}
                                                                    className={`${item?.associatedTasks?.status === "pending" ? "yellowStatus" : "greenStatus"} status fw-bold text-capitalize m-0 text-center d-flex align-items-center justify-content-center rounded-pill px-4 py-1`}
                                                                >
                                                                    {item?.associatedTasks?.status}
                                                                </p></div>
                                                            </div>
                                                            <div className='group-details-table'>
                                                                <TableLayout column={column} data={item?.occurrences || []} />
                                                            </div>
                                                        </div>
                                                    ))
                                                }
                                            </Container>
                                        </section>
                                    </>
                            }
                        </Accordion.Body>
                    </Accordion.Item>
                )
            }
        </Accordion>
    )
}
